import { Button } from '@mui/material';
import axios from 'axios';
import { BooleanField, Datagrid, List, TextField, useResourceContext } from 'react-admin';
import constants from '../../constants';

const SettingList = () => {
	const context = useResourceContext({ resource: 'setting' });
	// GH-766 — the banner block (show toggle + image upload) moved to its own page "באנר ראשי" (/main-banner).

	return (
		<>
			<List
				resource="setting/all"
				actions={
					<Button
						onClick={async () => {
							const res = await axios.post(`${constants.API_URL}/admin/generate-api-key`);
							alert(res.data?.rawKey);
						}}
					>
						צור API KEY
					</Button>
				}
			>
				<Datagrid rowClick="edit" resource={context}>
					<TextField source="key" />
					<BooleanField source="value" />
				</Datagrid>
			</List>
		</>
	);
};
export default SettingList;
